import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API } from 'api';
import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

import { apiBasePath, apiName } from 'assets';
import { Kit } from '@repo/types';

const patchKit = async (kit: Partial<Kit>) => {
  if (!kit.id) throw new Error('No Kit Id provided');
  if (!kit.tinyaccount_id) throw new Error('No tiny account Id for kit');

  await API.patch(
    apiName,
    `${apiBasePath}/kits/${kit.id}/tinyaccount/${kit.tinyaccount_id}`,
    {
      body: {
        ...kit,
      },
    },
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.KITS,
        domain: DOMAINS.KITS,
        importance: IMPORTANCE.HIGH,
      },
      context: {
        kitId: kit.id,
        tinyAccountId: kit.tinyaccount_id,
      },
    },
  );
};

const useUpdateKit = () => {
  const queryClient = useQueryClient();
  const kitMutation = useMutation({
    mutationFn: (newKit: Partial<Kit>) => {
      return patchKit(newKit);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['kits'],
        refetchType: 'all',
      });
    },
  });
  return kitMutation;
};

export default useUpdateKit;
